import React from "react";
import { Map, Marker, TileLayer, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import { connect } from "react-redux";
import { VehicletypesMonitoringDriversAction, TrackOrderDriverAction, GetDriverInfoAction, GetDriverOrderListAction } from "../../../../Redux/actions/actions";
// import { Marker as LeafletMarker } from "leaflet-rotatedmarker";
import { CanTrackDriver, getBaseTrackByUrl } from "../../../../helper/module";
import { SocketTrackDriver } from "../../../../service/socket/Emit_handelers";
import deliveryProfile from "../../../../assets/delivery-man.png";
import Pin from "../Pin";
import ReactDOMServer from "react-dom/server";
import { SetDriverListOpenDialoge, SetDriverLocation, SetDriverPopUp } from "../../../../Redux/actions/actionNames";

const createtIcon = ( driver) => {
  return new L.divIcon({
    className: "",
    html: ReactDOMServer.renderToString(CreateDriverPinOsm( driver)),
    iconSize: [54, 57],
    iconAnchor: [37, 67],
  });
};


const CreateDriverPinOsm = ( data) => {
  return  <Pin hasActiveOrder={true} driver={data}  isOnline={data.isOnline} />
};
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      location: null,
      last_location: null,
      deg: 0,
    };
    this.intervall = null;
  }

   componentDidMount() {
     console.log("fefewff ef " , this.props.routeDetails)
     if (this.props.routeDetails && this.props.routeDetails?.route.status ==  "Started") {
       this.props.dispatch(GetDriverInfoAction(this.props.dispatch, this.props.routeDetails?.route?.driver?.id, (call) => {
          this.setState({
           data: call,
           location: call.location,
         });
       }))
       this.intervall = setInterval(() => {
         this.props.dispatch(GetDriverInfoAction(this.props.dispatch, this.props.routeDetails?.route?.driver?.id, (call) => {
           this.setState({
            data: call,
            location: call.location,
          });
        }))
       }, 5000);
     }
   }

  componentWillReceiveProps(nextProps) {
 
    if (nextProps.routeDetails && nextProps.routeDetails?.route.status ==  "Started" && !this.intervall) {

      this.props.dispatch(GetDriverInfoAction(nextProps.dispatch, nextProps.routeDetails?.route?.driver?.id, (call) => {
        this.setState({
         data: call,
         location: call.location,
       });
     }))

      this.intervall = setInterval(() => {
        this.props.dispatch(GetDriverInfoAction(nextProps.dispatch, nextProps.routeDetails?.route?.driver?.id, (call) => {
          this.setState({
           data: call,
           location: call.location,
         });
       }))
      }, 5000);
    } else if(nextProps.routeDetails?.route.status !=  "Started" && (this.intervall )) {
 
      clearInterval(this.intervall);
    }
  }

  componentWillUnmount(){
    this.setState({
      data: null,
      location: null,
      last_location: null,
    })
    clearInterval(this.intervall);

  }

  openProfile=()=>{
  
  }

  render() {

    if (
      this.props.routeDetails?.route.status ==  "Started"  &&
      this.state.data && this.state.location
    ) {
      return (
        <React.Fragment>
          <Marker
            animate={true}
            position={{
              lat: this.state.location[1],
              lng: this.state.location[0],
            }}
            icon={createtIcon(this.state.data)}
            onClick={this.openProfile}
          ></Marker>

        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  OpenVRDialoge: state.ViewTravel.OpenDialoge,
  pureData: ownProps.VRpureData,
  status: state.ViewTravel.pureData ? state.ViewTravel.pureData.status : "",
  id: state.ViewTravel.ID,
  type: state.ViewTravel.pureData ? state.ViewTravel.pureData.type : "",

  socket: state.Socket.socket,
  driver_location: state.ViewTravel.driver_location,
  driverId: state.ViewTravel.pureData ? state.ViewTravel.pureData.driverId : "",
  cursor: state.OrderList.cursor,
  cursorSort: state.OrderList.cursorSort,
  routeDetails : ownProps.routeDetails
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
